import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const colleges = [{
  id: 1,
  name: "휴먼복지학부",
  image: "https://first-pup.10web.cloud/wp-content/uploads/2026/06/ChatGPT-Image-2026년-6월-25일-오전-01_22_15-1.png?v=yf29y8ze7n"
}, {
  id: 2,
  name: "심리재활학부",
  image: "https://first-pup.10web.cloud/wp-content/uploads/2026/06/ChatGPT-Image-2026년-6월-25일-오전-01_22_16-3.png?v=t7oo2beqns"
}, {
  id: 3,
  name: "창의교육학부",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714548/img/asian_creative_education_classroom.png"
}, {
  id: 4,
  name: "미래공학부",
  image: "https://first-pup.10web.cloud/wp-content/uploads/2026/06/ChatGPT-Image-2026년-6월-25일-오전-01_22_16-4.png?v=z843bkr84f"
}, {
  id: 5,
  name: "실용서비스학부",
  image: "https://first-pup.10web.cloud/wp-content/uploads/2026/06/ChatGPT-Image-2026년-6월-25일-오전-01_22_17-5.png?v=ni5ssnl7bp"
}];
const departments = [{
  collegeId: 1,
  name: "사회복지학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab1"
}, {
  collegeId: 1,
  name: "노인복지학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab6"
}, {
  collegeId: 1,
  name: "보건의료복지학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab11"
}, {
  collegeId: 1,
  name: "사회복지경영학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab12"
}, {
  collegeId: 2,
  name: "상담심리치료학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab8"
}, {
  collegeId: 2,
  name: "행동발달치료학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab13"
}, {
  collegeId: 2,
  name: "심리운동치료학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab4"
}, {
  collegeId: 3,
  name: "다문화한국어학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab3"
}, {
  collegeId: 3,
  name: "아동복지학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab2"
}, {
  collegeId: 3,
  name: "온라인평생교육학과 (AI융합교육학과)",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab15"
}, {
  collegeId: 4,
  name: "산업안전소방학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab14"
}, {
  collegeId: 4,
  name: "전기전자공학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab16"
}, {
  collegeId: 5,
  name: "글로벌뷰티학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab9"
}, {
  collegeId: 5,
  name: "디지털마케팅학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab5"
}, {
  collegeId: 5,
  name: "반려동물관리학과",
  href: "https://go.kycu.ac.kr/bbs/sub_0103.php#tab10"
}];
export default function CollegesDepartments() {
  return <section id="collegesdepartments" className="bg-background py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {colleges.map((college, i) => <div key={college.id} data-index={i} className="flex flex-col rounded-lg overflow-hidden shadow-md border border-border bg-card">
              {}
              <div className="relative h-48 shrink-0">
                <img src={college.image} data-wvc-srcset={`${college.image}-wvc-srcset`} data-wvc-sizes={`${college.image}-wvc-sizes`} alt={college.name} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-x-0 bottom-0 h-16 bg-emerald-900/80 flex items-center justify-center px-4">
                  <h3 className="text-white font-default font-bold text-lg text-center">
                    {college.name}
                  </h3>
                </div>
              </div>

              {}
              <div className="bg-gray-100 p-4 flex-1 flex flex-col gap-2.5">
                {departments.filter(dept => dept.collegeId === college.id).map((dept, j) => <Button key={j} data-index={j} variant="outline" asChild className="w-full bg-white hover:bg-gray-50 text-foreground font-default rounded-lg h-auto py-2.5 px-3 whitespace-normal text-center border-gray-200 shadow-sm">
                      <Link to={dept.href}>{dept.name}</Link>
                    </Button>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}